import NavDivider from 'ext-ui/components/NavDivider/NavDivider'
import {
  base_colorContentBorder,
  text_colorTextPrimary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { transition_slower } from 'ext-ui/style/transitionSpeeds'
import { font_family_weight_medium, font_md } from 'ext-ui/style/typography'
import styled, { css } from 'styled-components'

export const SidenavContentNavGroupDivider = styled(NavDivider)`
  border: 0;
  width: 100%;
  height: 1px;
  background-color: ${base_colorContentBorder};
`

export const navGroup = css`
  display: flex;
  flex-direction: column;
  padding: ${spacing(3)} 0;
  gap: ${spacing(1)};
`

export const navGroupHeader = css`
  display: flex;
  align-items: center;
  height: 36px;
  ${font_md};
  font-family: ${font_family_weight_medium};

  transition: margin ${transition_slower} ease-in-out;

  &.open {
    margin: ${spacing(1)} ${spacing(4)};
  }

  &.closed {
    margin: ${spacing(1)} ${spacing(3)};
  }
`

export const navHeaderText = css`
  padding: 0 ${spacing(1)};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  border-radius: ${spacing(2)};

  transition: all ${transition_slower} ease-in-out;

  &.open {
    width: 100%;
    height: 18px; /* line height of font_md */
    background-color: transparent;
    color: ${text_colorTextPrimary};
  }

  &.closed {
    height: ${spacing(4)};
    width: ${spacing(4)};
    background-color: ${base_colorContentBorder};
    color: transparent;
  }
`
